import {
  collection,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  getDocs,
  serverTimestamp,
  deleteDoc,
} from 'firebase/firestore';
import { getFirestoreInstance } from './firestore';
import type { Item } from '@gigdriver/domain';
import { fromFirestore } from './serde';

function itemsCollection(orgId: string) {
  return collection(getFirestoreInstance(), 'organizations', orgId, 'items');
}

export async function createItem(
  orgId: string,
  item: Omit<Item, 'id' | 'orgId' | 'createdAt' | 'updatedAt'>,
): Promise<string> {
  const ref = doc(itemsCollection(orgId));
  await setDoc(ref, {
    ...item,
    id: ref.id,
    orgId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return ref.id;
}

export async function getItem(orgId: string, itemId: string): Promise<Item | null> {
  const ref = doc(getFirestoreInstance(), 'organizations', orgId, 'items', itemId);
  const snap = await getDoc(ref);
  return snap.exists() ? fromFirestore<Item>(snap.data()) : null;
}

export async function getOrgItems(orgId: string): Promise<Item[]> {
  const snap = await getDocs(itemsCollection(orgId));
  return snap.docs.map(d => fromFirestore<Item>(d.data()));
}

export async function updateItem(orgId: string, itemId: string, updates: Partial<Item>): Promise<void> {
  const ref = doc(getFirestoreInstance(), 'organizations', orgId, 'items', itemId);
  await updateDoc(ref, { ...updates, updatedAt: serverTimestamp() });
}

export async function deleteItem(orgId: string, itemId: string): Promise<void> {
  await deleteDoc(doc(getFirestoreInstance(), 'organizations', orgId, 'items', itemId));
}
